module.exports = __webpack_public_path__ + "static/media/game-background-pragmatics.d74b560b.jpg";